<template>
  <div class="smsCode">
    <van-nav-bar title="身份验证" left-arrow @click-left="$router.back()" />
    <div class="logo"></div>
    <div class="line"></div>
    <div class="phoneContainer">
      <input
        type="text"
        class="phone"
        v-model="username"
        placeholder="请输入手机号"
      />
      <div class="phone-icon"></div>
    </div>
    <div class="phoneContainer">
      <input
        type="text"
        class="phone"
        v-model="password"
        placeholder="请输入验证码"
      />
      <div class="password-icon"></div>
      <div class="code-btn" @click="getSmsCode" v-show="showGetCode">
        获取验证码
      </div>
      <div v-show="showReGet" class="code-btn">{{ time }}s后重新发送</div>
    </div>
    <div class="login-btn" @click="onSubmit">登 录</div>
    <!-- <div class="title">
      <div>Hi</div>
      <div>欢迎注册/登录</div>
    </div>
    <div class="getCode">
      <input type="text" class="phone" v-model="username" />
      <div class="getBtn" @click="getSmsCode" v-show="showGetCode">
        获取验证码
      </div>
      <div class="reGetCode" v-show="showReGet">{{ time }}s后重新发送</div>
    </div>
    <div class="line"></div>
    <input type="tel" v-model="password" class="input" maxlength="4" />
    <div class="codeContainer">
      <div
        v-for="(item, index) in codeLength"
        :key="index"
        class="code"
        v-text="codeArr[index]"
        @click="clickCode"
      ></div>
    </div>
    <div class="login" @click="onSubmit"></div>
    <div class="tip">
      <van-checkbox v-model="checked"
        >请您阅读并同意金箱科技
        <a @click="goUser">《用户协议》</a>
        、<a @click="goPrivacy">《隐私政策及 金箱服务条款》</a>
      </van-checkbox>
    </div> -->
  </div>
</template>

<script>
import { Toast } from "vant";
import { getSmCode, mobileLogin } from "@/api/phoneLogin.js";
import { getInfo } from "@/api/getToken.js";
export default {
  watch: {
    time: {
      handler(newVal) {
        if (newVal == 0) {
          clearInterval(this.timer);
          [this.showReGet, this.showGetCode] = [
            !this.showReGet,
            !this.showGetCode,
          ];
          this.time = 60;
        }
      },
    },
  },
  computed: {
    codeArr() {
      return this.password.split("");
    },
  },
  data() {
    return {
      password: "",
      codeLength: 4,
      username: "",
      showGetCode: true,
      showReGet: false,
      time: 60,
      timer: null,
      checked: false,
    };
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    goUser() {
      this.$router.push("/legal-agreement/gm/terms/user-agreement");
    },
    goPrivacy() {
      this.$router.push("/legal-agreement/gm/terms/privacy-agreement");
    },
    clickCode() {
      document.querySelector(".input").focus();
    },
    getSmsCode() {
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.username)) {
        Toast("请输入正确的手机号！");
        return;
      } else {
        [this.showReGet, this.showGetCode] = [
          !this.showReGet,
          !this.showGetCode,
        ];
        this.timer = setInterval(() => {
          this.time--;
        }, 1000);
        getSmCode({ mobile: this.username }).then((res) => {
          Toast({
            message: "发送成功！",
            position: "top",
          });
          document.querySelector(".input").focus();
          console.log(res, "smCode");
        });
      }
    },
    onSubmit() {
      const code = window.localStorage.getItem("code");
      mobileLogin(this.username, this.password).then((res) => {
        window.localStorage.setItem("phoneNumber", this.username);
        window.localStorage.setItem("token", res.data.data.access_token);
        console.log(res, "login");

        this.$router.go(-1);
        // getInfo({ code: code, type: "WX" }).then((res) => {
        //   if (res.data.data) {
        //     this.$router.replace("/salesList");
        //   }
        //   window.localStorage.removeItem("code");
        // });
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-icon {
  color: #000000;
}
::v-deep .van-nav-bar__title {
  color: #000000;
  font-weight: 500;
}
.logo {
  width: 134px;
  height: 268px;
  background: url("../../../assets/loginLogo.png") no-repeat;
  background-size: contain;
  margin: 0 auto;
  margin-top: 60px;
}
.phoneContainer {
  width: 574px;
  height: 88px;
  margin: 0 auto;
  margin-top: 80px;
  margin-left: 48px;
  position: relative;
}
.phone {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  outline: none;
  border: none;
  border-radius: 24px;
  padding-left: 80px;
}
.phone-icon {
  width: 40px;
  height: 40px;
  background: url(../../../assets/mobile.png) no-repeat;
  background-size: contain;
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-55%);
}
.password-icon:extend(.phone-icon) {
  background: url(../../../assets/lock-on.png) no-repeat;
  background-size: contain;
}
.code-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-55%);
  right: 24px;
  font-size: 28px;
  color: #2948ff;
}
.login-btn {
  width: 494px;
  height: 88px;
  background: linear-gradient(90deg, #396afc 0%, #2948ff 100%);
  border-radius: 24px 24px 24px 24px;
  line-height: 88px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 80px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #ededed;
}
.smsCode {
  padding: 0 40px;
  .title {
    width: 384px;
    height: 156px;
    margin-top: 108px;
    color: rgba(0, 0, 0, 1);
    font-size: 56px;
    font-weight: bold;
  }
  .getCode {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 88px;
    .phone {
      display: block;
      width: 262px;
      height: 100%;
      padding: 0;
      border: 0;
      color: rgba(0, 0, 0, 1);
      font-size: 36px;
      font-weight: bold;
      margin-left: 32px;
    }
    .getBtn {
      width: 145px;
      height: 37px;
      color: rgba(0, 73, 255, 1);
      font-size: 26px;
      cursor: pointer;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(226, 228, 234, 1);
    margin-top: 24px;
  }
  .codeContainer {
    margin-top: 40px;
    width: 100%;
    height: 74px;
    display: flex;
    justify-content: space-between;
    .code {
      width: 100px;
      height: 74px;
      border-bottom: 1px solid rgba(226, 228, 234, 1);
      text-align: center;
      font-size: 36px;
      color: rgba(0, 0, 0, 1);
      font-weight: bold;
    }
  }
  .login {
    width: 128px;
    height: 128px;
    background: url("../../../assets/login.webp") no-repeat;
    background-size: 100%;
    margin: 88px 0 0 494px;
  }
  .tip {
    width: 528px;
    height: 60px;

    margin: 0 auto;
    margin-top: 262px;
    font-size: 22px;
    text-align: center;
    position: relative;
    .tipCon {
      position: absolute;
      top: 0;
      left: -10;
    }
    a {
      color: blue;
    }
  }
}
.input {
  height: 1px;
  opacity: 0;
}
.reGetCode {
  font-size: 22px;
  color: rgba(226, 228, 234, 1);
}
::v-deep .van-checkbox__icon {
  position: absolute;
  top: 7px;
  left: -18px;
  font-size: 16px;
}
::v-deep .van-checkbox__label {
  margin-left: 0;
  line-height: 30px;
}
</style>
